import type { TranslationDict } from './ja'

export const zhHant: TranslationDict = {
  appTitle: '幸運動物地盤戰',
  help: '玩法',
  helpAria: '玩法',
  settings: '設定',
  settingsAria: '設定',
  close: '關閉',
  closeAria: '關閉',
  player: '玩家',
  highscore: '最高分',
  start: '開始遊戲',
  staminaEmpty: '體力不足',
  ranking: '大家的地盤戰',
  difficultyTitle: '選擇難度',
  difficultyStart: '以此難度開始',
  back: '返回',
  today: '今天',
  weekly: '本週',
  alltime: '總榜',
  loading: '讀取中...',
  noScores: '還沒有戰績。來成為第一位地盤王！',
  loadFailed: '讀取失敗',
  you: '你',
  youConstant: '你',
  language: '語言',
  languageNote: '支援包含日語在內的18種語言。',
  bgm: 'BGM',
  se: '音效',
  soundEnableAria: '開啟聲音',
  soundDisableAria: '關閉聲音',
  adWatch: '看完整個廣告',
  adCancel: '暫不',
  rankSuffix: '名',
  earnedPoints: '獲得 {score}pt',
  helpGoalTitle: '🎯 遊戲目的',
  helpGoalText: '在 9x9 的棋盤上交替放置棋子，擴張自己的領地（同色棋子群）。最終得分高的玩家獲勝。',
  helpWinTitle: '🏆 勝利條件',
  helpWinFive: '在橫、豎、斜任意方向連成 5 個同色棋子即可立即獲勝',
  helpWinScore: '棋盤填滿後通過得分高低決定勝負（無平局）',
  helpScoreTitle: '💯 得分規則',
  helpLineBonus: '連線獎勵：每當達成 3 連、4 連或 5 連時獲得加分',
  helpClusterBonus: '領地獎勵：根據連接在一起的棋子群的大小獲得加分',
  helpKomi: '貼目：後手方可獲得得分 +10% 的補償分',
  helpControlsTitle: '🖱️ 操作說明',
  helpControlsText: '輪到你的回合時，點擊棋盤上的空位即可放置棋子。',
  helpTipsTitle: '💡 小提示',
  helpTipHell: '想要挑戰自我，請嘗試最難的 HELL 難度',
  helpTipCluster: '不僅要追求 5 連，擴大棋子群也是提高得分的關鍵',
  resultWinFive: '🎉 達成 5 連！你贏了！',
  resultWinScore: '🎉 分數勝出！你獲得了完勝！',
  resultLoseFive: '😿 CPU 達成 5 連... 你輸了。',
  resultLoseScore: '😿 分數落後... 下次加油！',
  resultDraw: '🤝 平局',
  newHighscore: '🏆 刷新最高分！',
  scoreNone: '暫無分數',
  clusterBonus: '棋子群獎勵',
  retry: '再玩一次',
  titleBack: '返回標題',
  scoreHintPlaceStone: '請落子',
  best: '最高',
  clusterUnit: '個群體',
  lineCount: '{len}連 x{count}',
  turnCount: '第 {count} 手 · {difficulty}',
  boardPlayerPiece: '你的棋子',
  boardCpuPiece: 'CPU 的棋子',
  boardPlayerAlt: '你',
  boardCpuAlt: 'CPU',
  boardCellPosition: '第 {row} 行，第 {col} 列',
  boardPlaceable: '可放置',
  boardEmpty: '空格',
  boardFlower: '有花',
  firstPlayerAlt: '先手',
  playerFirst: '你是先手！',
  playerSecond: '你是後手（獲得 +{bonus}% 貼目獎勵）',
  cpuFirst: 'CPU 是先手！',
  finalePlayerWin: '你贏了！',
  finaleCpuWin: 'CPU 獲勝！',
  finaleFive: '達成 5 連！',
  finaleTerritory: '領地之爭！',
  winnerAlt: '獲勝者',
  loadingBoot: '啟動中...',
  loadingConnect: '連接中...',
  loadingProfile: '正在讀取資料...',
  loadingAssets: '正在讀取資源...',
  loadingReady: '準備就緒',
  reauthRequiredTitle: '需要重新登入',
  startupFailedTitle: '啟動失敗',
  reauthButton: '重新登入',
  reloadButton: '重新讀取',
  lineReloginButton: 'LINE 重新登入',
  reauthReason: '登入已過期。請重新登入。',
  errorReauth: '登入已過期。請重新登入。',
  errorForbidden: '你沒有權限使用此遊戲。',
  errorNotFound: '未找到遊戲數據。',
  errorRateLimited: '通信頻繁，請稍後再試。',
  errorServer: '無法連接到伺服器。請稍後重新讀取。',
  errorCommunication: '發生通信錯誤。請重新讀取。',
  errorNetwork: '無法連接到網路。請檢查網路狀態並重新讀取。',
  errorStartup: '啟動失敗。請重新讀取。',
  settingsTabGeneral: '設定',
  settingsTabAccount: '帳號',
  settingsTabInfo: '信息',
  account: '帳號',
  linked: '已關聯',
  guest: '遊客',
  loggedInWith: '已通過 {provider} 帳號登入',
  loggedIn: '已登入帳號',
  playingAsGuest: '當前正以遊客身份遊戲。',
  appleLoginBusy: '正在登入 Apple...',
  appleLogin: '通過 Apple 登入',
  googleLoginBusy: '正在登入 Google...',
  googleLogin: '通過 Google 登入',
  logoutBusy: '正在註銷...',
  logout: '註銷',
  logoutSuccess: '已成功註銷',
  logoutFailed: '註銷失敗',
  appInfo: '應用信息',
  appName: '應用名稱',
  version: '版本',
  legalInfo: '法律信息',
  terms: '使用條款',
  privacy: '隱私政策',
  operator: '運營者',
  contact: '聯繫我們',
  copyTap: '點擊複製',
  idCopied: 'ID 已複製',
  copyFailed: '複製失敗',
  other: '其他',
  reportAd: '舉報不當廣告',
  privacyChoices: 'Ad privacy choices',
  profileEdit: '編輯資料',
  displayName: '顯示名稱',
  displayNamePlaceholder: '輸入名稱',
  chooseIcon: '選擇頭像',
  iconLoadFailed: '無法獲取頭像列表。',
  saveFailed: '保存失敗。請重試。',
  noIcons: '沒有可用的頭像。',
  save: '保存',
  saving: '正在保存...',
  staminaAria: '體力值 {stamina} / {max}',
  nextRecovery: '距離下次恢復還有 {time}',
  adPlaying: '廣告播放中...',
  recoverFullAd: '看廣告完全恢復體力',
  dailyBonusAria: '看完整個廣告獲得體力+5',
  dailyBonusAd: '看廣告獲得體力+5',
  legalLastUpdated: '最後更新日期：{date}',
  privacyTitle: '隱私政策',
  termsTitle: '使用條款',
  adPlayingAria: '正在播放廣告',
  adBadge: '▶ 廣告',
  adRemaining: '剩餘 {seconds} 秒',
  adDevHint: '※ 這是開發用的模擬廣告。在正式版中將播放 AdMob 視頻廣告。',
  adRewardRequirement: '看完整個廣告即可獲得以下獎勵。',
  adRewardStaminaDetail: '獎勵：體力恢復到上限',
  adRewardDailyBonusDetail: '獎勵：今日一次性獎勵體力 +{amount}',
  adRewardIncompleteNote: '中途關閉將無法獲得獎勵。',
  adSkipAria: '跳過廣告',
  adSkip: '跳過 ✕',
  adSkipAfter: '{seconds} 秒後可跳過',
  offlineMessage: '無法連接到伺服器。部分功能可能無法使用。',
  reconnecting: '正在重新連接...',
  reconnect: '重新連接',
  signInTitle: '登入',
  signInBusy: '正在登入...',
  signInCancelNote: '取消登入後將繼續以遊客身份遊玩（部分功能將受限）。',
  processing: '處理中...',
  recoverConfirmTitle: '數據覆蓋確認',
  recoverConfirmMessage: '該登入帳號下已有數據。繼續操作將替換當前設備上的遊客數據。確定要繼續嗎？',
  recoverConfirmContinue: '覆蓋並繼續',
  recoverConfirmCancel: '取消',
  unlinkConfirmTitle: '解除關聯',
  unlinkConfirmMessage: '解除與此平台的關聯後，此設備將返回遊客狀態。如果您在其他設備上使用相同平台登入，Hub 上的數據依然保留。',
  unlinkConfirmContinue: '解除關聯',
  unlinkConfirmCancel: '取消',
  deleteConfirmTitle: '確認註銷帳號',
  deleteConfirmMessage: '刪除帳號將丟失所有最高分、登入信息、關聯帳號及邀請關係。\n此操作不可撤銷。確定要註銷嗎？',
  deleteConfirmContinue: '註銷帳號',
  deleteConfirmCancel: '取消',
  adNekoTitle: '廣告貓',
  matchmakingRemaining: '剩餘 {seconds} 秒',
  matchmakingTimeoutMessage: '未能在時間內找到對手。請再試一次。',
  difficultyEasyName: '入門',
  difficultyEasyDescription: '對手看起來有點心不在焉',
  difficultyNormalName: '普通',
  difficultyNormalDescription: '對手偶爾會犯點小錯誤',
  difficultyHardName: '困難',
  difficultyHardDescription: '對手的視野非常開闊',
  difficultyHellName: '狂暴',
  difficultyHellDescription: '對手非常強大，且精於預判',
}
